import api from 'helpers/api'
import { ITableViewWithColumns } from 'types'

export interface HydrateViewResult {
  view: ITableViewWithColumns
  parent: ITableViewWithColumns | null
}

export const hydrateView = async (viewId: string, tableView: ITableViewWithColumns[]): Promise<HydrateViewResult> => {
  const existing = tableView.find((v) => v.publicId === viewId)
  if (existing?.columnsHydrated) {
    return { view: existing, parent: null }
  }

  const viewResponse = await api.getTableView(viewId)
  const view = { ...viewResponse.data, columnsHydrated: true }

  const parentId = view.configurationParentView?.publicId
  if (!view.isPersonalView || !parentId) {
    return { view, parent: null }
  }

  const existingParent = tableView.find((v) => v.publicId === parentId)
  if (existingParent?.columnsHydrated) {
    return { view, parent: null }
  }

  const parentResponse = await api.getTableView(parentId)
  return { view, parent: { ...parentResponse.data, columnsHydrated: true } }
}
